import DataTableV2Mixin from '@/agilis/components/DataTableV2/DataTableV2'
import SearchPaginatedMixin from '@/agilis/components/DataTableV2/common/searchPaginatedMixin'

export default {
  name: 'DataTableV2Paginated',
  mixins: [DataTableV2Mixin, SearchPaginatedMixin]
}
